const backButton = document.querySelector( '.js-back-button' );

if ( backButton ) {
	backButton.addEventListener( 'click', e => {
		e.preventDefault();
		window.history.back();
	} );
}
